export const getRandomNumber = () => Math.floor(Math.random() * 10 + 1);
